import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, HelpCircle } from 'lucide-react';
import ScrollAnimation from '../ScrollAnimation';

export default function IrreplacableQuestionnaireSection() {
  const [showTypeform, setShowTypeform] = useState(false);

  return (
    <ScrollAnimation>
      <section className="relative py-20 bg-white">
        {/* Top border with gradient effect */}
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-primary/30 to-transparent" />
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 stagger-item">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Are you ready to receive feedback?
            </h2>
            <p className="text-xl text-gray-600">
              Ask yourself these 7 questions to assess your readiness
            </p>
          </div>

          <div className="flex justify-center">
            <button
              onClick={() => setShowTypeform(true)}
              className="bg-primary text-dark px-8 py-4 rounded-lg hover:bg-primary-hover transition-all duration-300 transform hover:-translate-y-1 shadow-lg hover:shadow-xl font-medium"
            >
              Open Free Questionnaire
            </button>
          </div>

          <AnimatePresence>
            {showTypeform && (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm"
              >
                <motion.div
                  initial={{ scale: 0.95, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  exit={{ scale: 0.95, opacity: 0 }}
                  className="relative w-full max-w-4xl h-[80vh] bg-white rounded-xl shadow-2xl"
                >
                  <button
                    onClick={() => setShowTypeform(false)}
                    className="absolute -top-4 -right-4 w-8 h-8 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-100 transition-colors z-10"
                  >
                    <X className="w-5 h-5 text-gray-600" />
                  </button>
                  
                  <iframe
                    className="typeform-widget w-full h-full"
                    src="https://insightalks.typeform.com/to/krtyccr0"
                    frameBorder="0"
                    title="Readiness Questionnaire"
                    allow="camera; microphone; autoplay; encrypted-media; fullscreen"
                  />
                </motion.div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>

        {/* Bottom border with gradient effect */}
        <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-primary/30 to-transparent" />
      </section>
    </ScrollAnimation>
  );
}